"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.authRoutes = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const pages_1 = require("../pages");
const Route_1 = require("./Route");
exports.authRoutes = [
    {
        path: Route_1.Route.Base,
        children: [
            {
                path: Route_1.Route.InterimScreen,
                children: [
                    {
                        path: Route_1.Route.InterimScreenOpen,
                        element: (0, jsx_runtime_1.jsx)(pages_1.InterimScreenOpenPage, { "data-e2e": 'InterimScreenOpenPage' }),
                    },
                    {
                        path: Route_1.Route.InterimScreenOpenTimeout,
                        element: (0, jsx_runtime_1.jsx)(pages_1.InterimScreenOpenTimeoutPage, { "data-e2e": 'InterimScreenOpenTimeoutPage' }),
                    },
                    {
                        path: Route_1.Route.InterimScreenProcess,
                        element: (0, jsx_runtime_1.jsx)(pages_1.InterimScreenProcessPage, { "data-e2e": 'InterimScreenProcessPage' }),
                    },
                ],
            },
        ],
    },
];
